import { RdvService } from '../../../../../providers/RdvService.js';
const rdvService = new RdvService();
export default {
  data() {
    return {
      lstCreneaux: [],
      refCreneau: null,
      serviceChoisi: null,
      souscriptionId: null,
      loading:false
    }
  },
  mounted() {
    var sessionSouscription = this.$globalService.getSessionSouscription();
    if(sessionSouscription == null || sessionSouscription.resultDossierScan == null || sessionSouscription.resultDossierScan.fullDocuments == null){
      this.loading = false;
      this.$dialog.notify.error(this.$root.errorMessage, {
        position: 'bottom-right',
        timeout: 5000
      })
      return;
    }
    this.serviceChoisi = sessionSouscription.serviceChoisi;
    this.souscriptionId = sessionSouscription.souscriptionId;
    
    this.queryCreneaux();
  },
  methods: {
    queryCreneaux: function() {
      
      rdvService.getCreneauxList(this.serviceChoisi.infra, this.serviceChoisi.ref_adresse, this.serviceChoisi.ref_immeuble)
        .then((res) => {
          if (res) {
            if (res.err != "error" && res.params) {
              this.lstCreneaux = res.params.creneaux;
            }
          }
        })
        .catch((error) => {
          
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
    },
    selCreneau: function() {
    },
    createRdv: function() {
      console.log("creneaux");
      if(!this.refCreneau) {
        this.$dialog.warning({
          text: "Veuillez sélectionner un créneau de rendez-vous",
          title: "Attention",
          persistent: false,
          actions: {
            false: "Fermer",
          },
        });
      } else {
        const site = this.$root.user.site;
        const domaine = this.$root.user.domaine;
        const creneau = this.refCreneau.split('|');
        this.loading = true;
        rdvService.createIntervention(this.souscriptionId, this.serviceChoisi.infra, this.serviceChoisi.ref_adresse, this.serviceChoisi.ref_immeuble, creneau[0], creneau[1], creneau[2], creneau[3], site, domaine)
        .then((res) => {
          this.loading = false;
          if (res) {
            if (res.err != "error" && res.params) {
              this.$globalService.setUser(res.params.user);
              this.$globalService.setSessionSouscription('resultRdvOrder',res.params.order);
              this.$globalService.setSessionSouscription('resultRdvDateHeure',creneau[4]);
              
              this.$router.push({name: 'RdvConfirmation'});
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });

      }
      
    },
    actualiser: function() {
      this.queryCreneaux();
    }
  }
}